{
  "index": {
    "new_custom_class": {
      "title": "Offer a New Class",
      "custom_class": {
        "title": "Custom Class",
        "description": "Click here to offer a new class with custom settings."
      }
    },
    "custom_class_list": {
      "title": "Custom Classes",
      "empty_list": "No classes. Click the add button to create your first class."
    },
    "custom_class_card": {
      "num_offered_one": "{{count}} class offered",
      "num_offered_other": "{{count}} classes offered"
    }
  },
  "new": {
    "page_title": "New Custom Class",
    "submit": "Create Custom Class"
  },
  "edit": {
    "page_title": "Edit Custom Class",
    "submit": "Update Custom Class"
  },
  "form": {
    "details": {
      "section_title": "Details",
      "name": "Name",
      "state": "State",
      "subject": "Subject",
      "min_students": "Minimum Students",
      "max_students": "Maximum Students",
      "num_classes": "Number of Classes",
      "timezone": "Teaching Timezone",
      "specialities": "Specialities",
      "specialities_multiselect_placeholder": "Please select all the specialities that apply to this class.",
      "specialities_select_profile": "Select a listing profile above to load specialities.",
      "specialities_load_error": "Failed to load specialities."
    },
    "structure": {
      "section_title": "Structure",
      "cycle_length": "Cycle Length",
      "live_sessions": "Live Sessions",
      "student_led_sessions": "Student-Led Sessions",
      "other_sessions": "Other Sessions",
      "week_one": "{{count}} Week",
      "week_other": "{{count}} Weeks",
      "sessions_input_one": "{{count}} session of {{duration}} minutes",
      "sessions_input_other": "{{count}} sessions of {{duration}} minutes",
      "sessions_input_count": "Count",
      "sessions_input_duration": "Duration",
      "sessions_input_count_label": "Number of Sessions",
      "sessions_input_duration_label": "Session Duration (minutes)",
      "sessions_input_count_placeholder": "Enter number of sessions",
      "sessions_input_duration_placeholder": "Enter duration in minutes",
      "sessions_input_group_label": "Session Configuration",
      "school_year_planner": "School Year Planner",
      "no_school_calendar_loaded": "No school calendar loaded. Select a state and subject to get started.",
      "cycles": "Cycles",
      "live_hours": "Live Hours",
      "student_led_hours": "Student-Led Hours",
      "other_hours": "Other Hours",
      "total": "Total",
      "extra_days": "Extra Days",
      "edit_term_dates": {
        "button": "Edit term dates...",
        "dialog_title": "Edit Term Dates",
        "dialog_description": "Make changes to your school calendar here. Click close when you're done."
      }
    },
    "availability": {
      "section_title": "Availability",
      "no_availability": "No availability specified. Please select the times on the calendar or use the form above to specify when you will be available for consultations.",
      "availability_notes": "Availability Notes",
      "overlapping_error": "The time you selected overlaps with another time slot.",
      "invalid_error": "The time you selected is invalid.",
      "day": "Day",
      "start_time": "Start Time",
      "end_time": "End Time",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    }
  }
}
